import React, {Fragment, useContext, useState} from 'react';
import { Card, CardBody, CardHeader, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { H5, H4, H6, P, Image, Btn } from '../../../../AbstractElements';
import { Link } from 'react-router-dom';
import { MyProfile, Bio, Password, Website, Save, EmailAddress } from '../../../../Constant';
import CustomizerContext from '../../../../_helper/Customizer';
import ManageUsers from "../../../../api/ManageUsers";

const MyProfileEdit = ({ reloadAction }) => {
  const { layoutURL } = useContext(CustomizerContext);

  const [userPhone, setUserPhone] = useState("");

  const handlePhoneChange = (e) => {
    setUserPhone(e.target.value)
  };

  const registerUserWithEmail = async (e) => {
    e.preventDefault();
    try {
      const userData = {
        phone_number: userPhone,
        role: 'admin'
      }
      console.log(userData);
      const response = await ManageUsers.addUser(userData);
      console.log(response.data.response.status_code)
      if ((response.data.response.status_code === 200) || (response.data.response.status_code === 201)) {
        setUserPhone("")
        reloadAction();
      }
      console.log('Utilisateur ajouté avec succès :', response);
    } catch (error) {
      console.error('Erreur lors de l\'ajout de l\'utilisateur :', error);
    }
  }


  return (
    <Fragment>
      <Card>
        <CardHeader>
          <H4 attrH4={{ className: 'card-title mb-0' }}>Ajouter un utilisateur</H4>
          <div className='card-options'>
            <a className='card-options-collapse' href='#javascript'>
              <i className='fe fe-chevron-up'></i>
            </a>
            <a className='card-options-remove' href='#javascript'>
              <i className='fe fe-x'></i>
            </a>
          </div>
        </CardHeader>
        <CardBody>
          <Form onSubmit={registerUserWithEmail}>
            {/*<Row className='mb-2'>
              <div className='profile-title'>
                <div className='media'>
                  <Image attrImage={{ className: 'img-70 m-0 rounded-circle', alt: '', src: `${require('../../../../assets/images/user/7.jpg')}` }} />
                  <div className='media-body'>
                    <Link to={`${process.env.PUBLIC_URL}/app/users/userProfile/${layoutURL}`}>
                      <H5 attrH5={{ className: 'mb-1' }}>MARK JECNO</H5>
                    </Link>
                    <P>DESIGNER</P>
                  </div>
                </div>
              </div>
            </Row>
            <FormGroup className='mb-3'>
              <H6 attrH6={{ className: 'form-label' }}>{Bio}</H6>
              <Input type='textarea' className='form-control' rows='5' defaultValue='On the other hand, we denounce with righteous indignation' />
            </FormGroup>*/}
            <FormGroup className='mb-3'>
              <Label className='form-label'>Numéro de téléphone</Label>
              <Input className='form-control' type='tel' placeholder='Numéro de téléphone' value={userPhone} onChange={handlePhoneChange}/>
            </FormGroup>
            <div className='form-footer'>
              <Btn attrBtn={{ className: 'btn-block', color: 'primary' }}>Enregistrer</Btn>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default MyProfileEdit;
